import defaultComponents from '$lib/storyblok/defaultComponents';
import OrderPage from '$lib/storyblok/pages/orderPage.svelte';
import LandingPageModuleHeadline from '$lib/storyblok/blocks/landingPageModuleHeadline.svelte';
import ProductCard from '$lib/storyblok/blocks/productCard.svelte';
import OrderPageHeader from '$lib/storyblok/blocks/orderPageHeader.svelte';
import { registerComponents } from '$lib/storyblok/sdk';

registerComponents({
	...defaultComponents,
	order_page: OrderPage,
	landing_page_module_headline: LandingPageModuleHeadline,
	product_card: ProductCard,
	order_page_header: OrderPageHeader,
	order_page_footer: import('$lib/storyblok/blocks/orderPageFooter.svelte')
});
